// ContentPipeline-UI Public API

export * from './lib/content-pipeline-ui.module';

// Child components
export { LandingComponent } from './lib/components/landing/landing.component';
export { RunDetailComponent } from './lib/components/run-detail/run-detail.component';
export { BlogDetailPanelComponent } from './lib/components/blog-detail-panel/blog-detail-panel.component';
export { BrandConfigComponent } from './lib/components/brand-config/brand-config.component';

export { ReviewQueueComponent } from './lib/components/review-queue/review-queue.component';
export { CalendarGridComponent } from './lib/components/calendar-grid/calendar-grid.component';
export { AgentSidebarComponent } from './lib/components/agent-sidebar/agent-sidebar.component';
export { SettingsDrawerComponent } from './lib/components/settings-drawer/settings-drawer.component';
export { NewsletterDetailPanelComponent } from './lib/components/newsletter-detail-panel/newsletter-detail-panel.component';
export { SocialPostDetailPanelComponent } from './lib/components/social-post-detail-panel/social-post-detail-panel.component';

// Shared components
export { StatusBadgeComponent } from './lib/components/shared/status-badge.component';
export { ContentCardComponent } from './lib/components/shared/content-card.component';
export { RunCardComponent } from './lib/components/shared/run-card.component';
export { ConfirmDialogComponent } from './lib/components/shared/confirm-dialog.component';

// Types
export * from './lib/types';

// CMO Dashboard
export { CMODashboardComponent, LoadCMODashboard } from './lib/components/cmo-dashboard/cmo-dashboard.component';

// Marketing Dashboard V2
export { MarketingDashboardV2Component, LoadMarketingDashboard } from './lib/components/marketing-dashboard-v2/marketing-dashboard-v2.component';

// Content Library
export { ContentLibraryComponent } from './lib/components/content-library/content-library.component';

// Analytics
export { AnalyticsSectionComponent } from './lib/components/analytics/analytics-section.component';

// Social Queue
export { SocialQueueSectionComponent } from './lib/components/social-queue/social-queue-section.component';

// Content Studio (Pipeline Composer)
export { PipelineComposerComponent } from './lib/components/content-studio/pipeline-composer.component';
export { PipelineSourceCardComponent } from './lib/components/content-studio/pipeline-source-card.component';
export { PipelineStepCardComponent } from './lib/components/content-studio/pipeline-step-card.component';
export { loadAgentStepTypes } from './lib/components/content-studio/content-studio.config';

// Marketing Workspace (card #887)
export { MarketingWorkspaceComponent, LoadMarketingWorkspace } from './lib/components/marketing-workspace/marketing-workspace.component';
export { CMOSupportChatComponent } from './lib/components/marketing-workspace/cmo-support-chat/cmo-support-chat.component';

// Loader imports
import { LoadCMODashboard } from './lib/components/cmo-dashboard/cmo-dashboard.component';
import { LoadMarketingDashboard } from './lib/components/marketing-dashboard-v2/marketing-dashboard-v2.component';
import { LoadMarketingWorkspace } from './lib/components/marketing-workspace/marketing-workspace.component';

/**
 * Call this function in your MJ Explorer startup to ensure all Marketing UI
 * components and resources are loaded and registered (prevents tree-shaking from removing them).
 */
export function LoadContentPipelineUI(): void {
    LoadCMODashboard();
    LoadMarketingDashboard();
    LoadMarketingWorkspace();
}
